export default __webpack_public_path__ + "static/media/1_thinkin.1ed2a0d5.svg";